import Constant from '@/common/constant/Constant';
import { updateApiPublic, deleteUserLog } from '@/graphql/mutations';
import API from '@/amplify/api';
import Storage from '@/amplify/storage';

export const pushClientLog = async (logs, loggerData) => {
    let paramsWithConfigOptions = {
        query: updateApiPublic,
        variables: {
            updateApiPublicRequestDto: JSON.stringify({
                updateApiType: Constant.UPDATE_API_PUBLIC_TYPE.PUSH_LOG_CLIENT,
                errorObject: logs,
                loggerData: loggerData
            })
        },
        options: {
            fetchPolicy: 'network-only'
        }
    };

    API.graphql(paramsWithConfigOptions)
        .then(res => {
            // do nothing
        })
        .catch(err => {
            console.log(err);
        });
};

export const getLogFileUploadTicketByCsv = async keyFile => {
    try {
        let getFileResult = await Storage.get(keyFile, {
            download: true,
            cacheControl: 'no-cache'
        });
        return await new Response(getFileResult.Body).json();
    } catch (error) {
        console.log('getLogUploadTicketByCsv', error);
        return;
    }
};

export const getAllLogFileUploadTicketByCsv = async (listFileCache, prefixFolder) => {
    try {
        return await Promise.all(
            listFileCache.map(async file => {
                const fileKey = prefixFolder + file.uploadKey.replace('public/', '');
                const contentFile = await getLogFileUploadTicketByCsv(fileKey);
                return contentFile;
            })
        );
    } catch (error) {
        console.log('getAllLogFileUploadTicketByCsv', error);
        return;
    }
};

/**
 * delete user log
 * @param {*} API
 * @param {*} ticketId
 * @returns
 */
export const deleteUserLogs = async requestDto => {
    try {
        const result = await API.graphql({
            query: deleteUserLog,
            variables: {
                deleteUserLogRequestDto: requestDto
            }
        });

        return result.data;
    } catch (err) {
        console.log('deleteUserLogs', err);
        return null;
    }
};

export const pingServerConnect = async () => {
    let paramsWithConfigOptions = {
        query: updateApiPublic,
        variables: {
            updateApiPublicRequestDto: JSON.stringify({
                updateApiType: Constant.UPDATE_API_PUBLIC_TYPE.PING_SERVER_CONTENT
            })
        },
        options: {
            fetchPolicy: 'network-only'
        }
    };

    try {
        const res = await API.graphql(paramsWithConfigOptions);
        const updateApiPublicData = res?.data?.updateApiPublic;
        return { success: updateApiPublicData?.success ?? false };
    } catch (err) {
        console.log('pingServerConnect err: ', err);
        return { success: false };
    }
};

export const oauth2callback = async req => {
    let paramsWithConfigOptions = {
        query: updateApiPublic,
        variables: {
            updateApiPublicRequestDto: JSON.stringify({
                ...req
            })
        },
        options: {
            fetchPolicy: 'network-only'
        }
    };

    try {
        const res = await API.graphql(paramsWithConfigOptions);
        const updateApiPublicData = res?.data?.updateApiPublic;
        return updateApiPublicData;
    } catch (err) {
        console.log('pingServerConnect err: ', err);
        return false;
    }
};

// export const oauth2callback2 = async req => {
//     let paramsWithConfigOptions = {
//         query: externalApiUpdate,
//         variables: {
//             externalApiUpdateRequestDto: JSON.stringify({
//                 updateApiType: 'oauth2callback',
//                 ...req
//             })
//         },
//         options: {
//             fetchPolicy: 'network-only'
//         }
//     };

//     try {
//         const res = await API.graphql(paramsWithConfigOptions);
//         const externalApiUpdateData = res?.data?.externalApiUpdate;
//         return { success: externalApiUpdateData?.success ?? false };
//     } catch (err) {
//         console.log('pingServerConnect err: ', err);
//         return { success: false };
//     }
// };
